// Type identifier for each filter type

export enum FilterType {
    DATE = "date",
    NUMBER = "number",
    TEXT = "text"
}
